import { ONLINE_WAREHOUSE_ID } from '~/constants/warehouse';
import type { OfferBalance } from '~/types/Catalog';

/**
 * Максимальный extra_shipping_days среди выбранных товаров корзины.
 * Для каждого товара берётся минимальный extra_shipping_days среди его источников
 * (онлайн-склад или поставщики без pickup_store с остатком),
 * затем из всех товаров выбирается максимум — он определяет общий сдвиг сроков доставки.
 */
export function useExtraShippingDays() {
  const cartStore = useCartStore();

  const maxExtraShippingDays = computed(() => {
    const selectedItems = cartStore.selectedCartItems;
    if (!selectedItems.length) return 0;

    let max = 0;

    for (const item of selectedItems) {
      const sources = item.data.offer_balances.filter(
        (b: OfferBalance) =>
          b.balance > 0 &&
          b.warehouse.show &&
          (b.warehouse.id === ONLINE_WAREHOUSE_ID ||
            (b.warehouse.pickup_store === null && b.warehouse.id !== ONLINE_WAREHOUSE_ID)),
      );

      if (sources.length) {
        const minForItem = Math.min(...sources.map((b) => b.warehouse.extra_shipping_days));
        if (minForItem > max) max = minForItem;
      }
    }

    return max;
  });

  return { maxExtraShippingDays };
}
